export default __webpack_public_path__ + "static/3-fb2bf2f4c728427c9059314d58ebe2ad.png";